function cov_1zzymhwcaf() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Offer.tsx";
  var hash = "806957063766c26b02d49b1d3dd8667d8f01a339";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Offer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "806957063766c26b02d49b1d3dd8667d8f01a339"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1zzymhwcaf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1zzymhwcaf();
var Icon = (cov_1zzymhwcaf().s[0]++, {
  name: 'offer',
  svg: "<path d=\"M4.25 5C4.25 4.0335 5.0335 3.25 6 3.25H18C18.9665 3.25 19.75 4.0335 19.75 5V19C19.75 19.9665 18.9665 20.75 18 20.75H6C5.0335 20.75 4.25 19.9665 4.25 19V5ZM8.25 9.5498C9.63071 9.5498 10.75 8.43052 10.75 7.0498C10.75 5.66909 9.63071 4.5498 8.25 4.5498C6.86929 4.5498 5.75 5.66909 5.75 7.0498C5.75 8.43052 6.86929 9.5498 8.25 9.5498ZM8 9.75C6.75736 9.75 5.75 10.7574 5.75 12C5.75 12.8707 6.24461 13.6259 6.9682 14C6.24461 14.3741 5.75 15.1293 5.75 16C5.75 17.2426 6.75736 18.25 8 18.25H16C17.2426 18.25 18.25 17.2426 18.25 16C18.25 15.1293 17.7554 14.3741 17.0318 14C17.7554 13.6259 18.25 12.8707 18.25 12C18.25 10.7574 17.2426 9.75 16 9.75H8Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\"2.5\"/>"
});
export default Icon;